<template>
    <div class="checkout-page">
        <AppHero :heading="'Checkout'">
            <div class="center-button">
                <stripe-checkout
                    ref="checkoutRef"
                    mode="payment"
                    :pk="publishableKey"
                    :line-items="lineItems"
                    :success-url="successURL"
                    :cancel-url="cancelURL"
                    @loading="v => loading = v"
                    :session-id="sessionID"
                />
                <button @click="submit" class="btn">Pay now!</button>
            </div>
        </AppHero>
    </div>
</template>

<script>
    import {StripeCheckout} from '@vue-stripe/vue-stripe';
    import AppHero from "@/components/layout/AppHero";

    export default {
        metaInfo: {
            title: 'Khonsu - Checkout'
        },
        components: {
            StripeCheckout,
            AppHero
        },
        computed: {
            sessionID() {
                return sessionStorage.getItem("user_id");
            }
        },
        data() {
            this.publishableKey = 'pk_test_51HGS5ZAL1yKA20YMuNRjqFS5idqTvFIcf7TajxPbXbOwvXN3QO5gWqV32MrHddmjTCPv3qGpXbbiDAwHx6Bo6kuQ00yqYGVypp'//process.env.STRIPE_PUBLISHABLE_KEY;
            return {
                publishableKey: 'pk_test_51HGS5ZAL1yKA20YMuNRjqFS5idqTvFIcf7TajxPbXbOwvXN3QO5gWqV32MrHddmjTCPv3qGpXbbiDAwHx6Bo6kuQ00yqYGVypp',
                loading: false,
                sessionId: 'session-id',
                lineItems: [
                    {
                        price: 'price_1JPoQTAL1yKA20YMUfS6oP6x', // The id of the one-time price you created in your Stripe dashboard
                        quantity: 1,
                    },
                ],
                successURL: 'https://khonsu.pragmaticdigital.co.uk/payment-success',
                cancelURL: 'https://khonsu.pragmaticdigital.co.uk/payment-failure',
            };
        },
        methods: {
            submit() {
                // You will be redirected to Stripe's secure checkout page
                this.$refs.checkoutRef.redirectToCheckout();
            },
        },
    };
</script>